import { useEffect, useState, useRef } from "react";
import PageHeader from "../../../component/pageheader";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Form, Input, Button, message, Select } from "antd";
import uploadImg from "../../../assets/image/Group 225.svg";

import Loadingbox from "../../../component/loadingbox";
import moment from "moment";
import { uploadImageToS3WebStories } from "../../../config/s3config/s3fileUpload";
import { API } from "../../../config/API";
import { GET, POST, PUT } from "../../../utils/apirequest";
import { LoadTags } from "../../../utils/commonapis";

const HighlightsNewForm = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state?.editData;
  const [form] = Form.useForm();
  const [imageUrl, setImageurl] = useState("");
  const [isLoading, setIsloading] = useState(true);
  const [tags, setTags] = useState<any>([]);
  const [loading3, setLoading3] = useState(true);
  const [tagFilter, setTagFilters] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    loadTags(tagFilter);
  }, [tagFilter]);

  useEffect(() => {
    if (editData) {
      // Populate image
      if (editData.media) {
        setImageurl(editData.media);
        setIsloading(false);
      }

      // Populate form fields - use setTimeout to ensure form is ready
      const tagIds =
        editData.tags && Array.isArray(editData.tags)
          ? editData.tags.map((tag: any) => tag.id || tag)
          : [];

      const formValues = {
        permalink: editData.permalink || "",
        description:
          editData.description !== null && editData.description !== undefined
            ? editData.description
            : "",
        tags: tagIds,
      };

      // Set form values after a brief delay to ensure form is mounted
      setTimeout(() => {
        form.setFieldsValue(formValues);
      }, 100);
    }
  }, [editData, form]);

  const loadTags = async (searchTerm: any) => {
    setLoading3(true);
    try {
      const res: any = await LoadTags(searchTerm);
      if (res && Array.isArray(res)) {
        setTags(res);
      } else {
        setTags([]);
      }
    } catch (error) {
      // Silently handle error - tags are optional
      setTags([]);
      console.warn("Failed to load tags:", error);
    } finally {
      setLoading3(false);
    }
  };
  function debounce(func: any, delay: any) {
    let timer: any;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const OnTagSearch = debounce((value: any) => {
    setTagFilters(value);
  }, 200);

  const onFinish = async (values: any) => {
    // Ensure tags is either an array of IDs or undefined (not empty array or null)
    const tagsArray =
      values?.tags && Array.isArray(values.tags) && values.tags.length > 0
        ? values.tags
        : undefined;

    let requestObj = {
      data: {
        media: imageUrl ? imageUrl : "",
        likes: editData?.likes || 0,
        comments: editData?.comments || "",
        shares: editData?.shares || 0,
        ...(tagsArray && { tags: tagsArray }), // Only include if tags exist
        permalink: values.permalink,
        description: values.description || "",
        is_expired: editData?.is_expired || false,
      },
    };

    console.log(
      "Highlights create request payload:",
      JSON.stringify(requestObj, null, 2),
    );

    try {
      if (editData && editData.id) {
        // Update existing highlight
        let url = API.HIGHLIGHTS + `/${editData.id}`;
        const response: any = await PUT(url, requestObj);
        if (response?.data?.id) {
          message.success("Successfully Updated");
          navigate("/Auth/highlights");
        } else {
          console.error("Update response error:", response);
          message.error(
            response?.error?.message ||
              "Failed to update highlight. Please try again.",
          );
        }
      } else {
        // Create new highlight
        let url = API.HIGHLIGHTS;
        const response: any = await POST(url, requestObj);
        if (response?.data?.id) {
          message.success("Successfully Created");
          navigate("/Auth/highlights");
        } else {
          console.error("Create response error:", response);
          message.error(
            response?.error?.message ||
              "Failed to create highlight. Please try again.",
          );
        }
      }
    } catch (error: any) {
      console.error("Error saving highlight:", error);
      console.error("Error details:", {
        status: error?.status,
        statusText: error?.statusText,
        errorData: error?.data,
        errorMessage: error?.error?.message,
        fullError: error,
      });

      // Handle different error structures
      const errorMessage =
        error?.error?.message ||
        error?.data?.error?.message ||
        error?.response?.data?.error?.message ||
        error?.message ||
        `Failed to save highlight${
          error?.status ? ` (HTTP ${error.status})` : ""
        }. Please try again.`;

      message.error(errorMessage);
    }
  };

  const uploadImage = async (val: any, files: any) => {
    const fileName = `${moment().format(
      "YYYY-MM-DD HH:mm:ss",
    )}suprabhatham-webstories.png`;
    const file = val.target.files[0];
    const response = await uploadImageToS3WebStories(file);
    setImageurl(response.data.imageUrl);
    setIsloading(false);
  };

  return (
    <>
      <div>
        <PageHeader
          title={editData ? "Edit Highlights" : "Create Highlights"}
          goBack={() => navigate("/Auth/highlights")}
        />
        <div style={{ height: "90vh", overflowY: "scroll" }}>
          <Form
            form={form}
            onFinish={onFinish}
            initialValues={(() => {
              const initVals = {
                permalink: editData?.permalink || "",
                description:
                  editData?.description !== null &&
                  editData?.description !== undefined
                    ? editData.description
                    : "",
                tags:
                  editData?.tags && Array.isArray(editData.tags)
                    ? editData.tags.map((tag: any) => tag.id || tag)
                    : [],
              };
              return initVals;
            })()}
          >
            <Row>
              <Col xs={1} />
              <Col xs={4}>
                <div className="formLabel" style={{ marginBottom: "10px" }}>
                  Image
                </div>
                {imageUrl ? (
                  <>
                    {isLoading ? (
                      <Loadingbox />
                    ) : (
                      <div className="highlights-form-image-preview">
                        <img
                          className="highlights-preview-img"
                          src={imageUrl}
                          alt="Preview"
                        />
                        <div style={{ marginTop: "12px", display: "flex", gap: "8px" }}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => fileInputRef.current?.click()}
                          >
                            Change
                          </Button>
                          <Button
                            type="default"
                            size="small"
                            danger
                            onClick={() => {
                              setImageurl("");
                              setIsloading(true);
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/*"
                          onChange={(val) => uploadImage(val, __filename)}
                          style={{ display: "none" }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="webStoriesForm-imgUpldr">
                    <img src={uploadImg} alt="" />
                    <Input
                      className="inputFile"
                      type="file"
                      accept="image/*"
                      onChange={(val) => uploadImage(val, __filename)}
                    />
                    <div className="webstories-imgTxt">Upload Image Here</div>
                  </div>
                )}
              </Col>
              <Col xs={6}>
                <label className="newsFormLabels">Tags</label>
                <Form.Item name="tags">
                  <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option?.children
                        ?.toLowerCase()
                        ?.indexOf(input.toLowerCase()) >= 0
                    }
                    loading={loading3}
                    onSearch={(val) => OnTagSearch(val)}
                  >
                    {tags.length > 0 &&
                      tags.map((item: any, index: any) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.tag}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
                <label className="newsFormLabels">Perma Link</label>
                <Form.Item name="permalink">
                  <Input placeholder="" />
                </Form.Item>
                <label className="newsFormLabels">Description</label>
                <Form.Item name="description">
                  <Input.TextArea rows={4} placeholder="Enter description" />
                </Form.Item>
                <Row style={{ marginBottom: "32px" }}>
                  <Col xs={6}></Col>
                  <Col xs={3}>
                    <Button block onClick={() => navigate("/Auth/highlights")}>
                      Cancel
                    </Button>
                  </Col>
                  <Col xs={3}>
                    <Button block type="primary" htmlType="submit">
                      publish
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col xs={1} />
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default HighlightsNewForm;
